import React, { useEffect } from 'react';

import { Button, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ReactHookFormIntlNumberInput from 'common/components/form/bootstrap/ReactHookFormIntlNumberInput';
import ShowErrors from 'common/components/ShowErrors';
import yupResolver from 'common/utils/yupResolver';

import * as actions from '../actions';
import * as selectors from '../selectors';
import validate from '../validate';

const LoadsForm = ({ errors, initialValues, isSavingProject, saveProject }) => {
    const { t } = useTranslation();
    const { control, handleSubmit, reset } = useForm({
        defaultValues: initialValues,
        resolver: yupResolver(validate),
    });

    useEffect(() => reset(initialValues), [initialValues]);

    const handleClickSave = (values) => saveProject(values);

    return (
        <form>
            <Grid container>
                <Grid size="grow">
                    <ReactHookFormIntlNumberInput
                        control={control}
                        fullWidth
                        label={t('Wind speed')}
                        name="wind_speed"
                    />

                    <ReactHookFormIntlNumberInput
                        control={control}
                        fullWidth
                        label={t('Snow load')}
                        name="snow_load"
                    />

                    <ShowErrors errors={errors || []} />

                    <Button
                        disabled={isSavingProject}
                        fullWidth
                        onClick={handleSubmit(handleClickSave)}
                        sx={{ textTransform: 'initial' }}
                        variant="outlined"
                    >
                        {isSavingProject
                            ? t('Saving').concat('...')
                            : t('Save')}
                    </Button>
                </Grid>
            </Grid>
        </form>
    );
};

const mapStateToProps = createStructuredSelector({
    errors: selectors.getSaveProjectErrors,
    initialValues: selectors.getInitialValues,
    isSavingProject: selectors.getProjectIsSaving,
});

const mapDispatchToProps = (dispatch) => ({
    saveProject: (values) => dispatch(actions.saveProject(values)),
});

LoadsForm.propTypes = {
    errors: PropTypes.array,
    initialValues: PropTypes.object,
    isSavingProject: PropTypes.bool,
    saveProject: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoadsForm);
